declare namespace $ {

	export class $bog_builderui_breadcrumbs extends $mol_view {
		items( ): readonly(any)[]
		sub( ): ReturnType< $bog_builderui_breadcrumbs['items'] >
	}
	
	export class $bog_builderui_breadcrumbs_item extends $mol_view {
		dom_name( ): string
		title( ): string
		path( ): string
		current( ): boolean
		sub( ): readonly(any)[]
		attr( ): ({ 
			'href': ReturnType< $bog_builderui_breadcrumbs_item['path'] >,
			'bog_builderui_breadcrumbs_current': ReturnType< $bog_builderui_breadcrumbs_item['current'] >,
		})  & ReturnType< $mol_view['attr'] >
	}
	
}

//# sourceMappingURL=breadcrumbs.view.tree.d.ts.map